// extracted by mini-css-extract-plugin
export default {"bloco":"StepName_bloco__dYcLu","campo":"StepName_campo__jHXnH","rotulo":"StepName_rotulo__cG5tx"};